import quotesJa from '../data/quotes.json';
import quotesEn from '../data/quotes-en.json';

export interface Quote {
  text: string;
  author: string;
}

/**
 * Get a random inspirational quote based on the current language
 * @param language - The language code ('ja' or 'en')
 * @returns {Quote} A random quote object with text and author
 */
export const getRandomQuote = (language: string = 'ja'): Quote => {
  const quotes = language === 'en' ? quotesEn : quotesJa;
  const randomIndex = Math.floor(Math.random() * quotes.length);
  return quotes[randomIndex];
};

/**
 * Get a formatted quote string with author attribution
 * @param language - The language code ('ja' or 'en')
 * @returns {string} Formatted quote string
 */
export const getFormattedRandomQuote = (language: string = 'ja'): string => {
  const quote = getRandomQuote(language);
  return `${quote.text} - ${quote.author}`;
};